import React, { useState, useEffect } from "react";
import portfolio from "data/Portfolio/list.json";
import withDimension from "utils/withDimension";
import PortfolioListMobile from "./PortfolioListMobile";
import PortfolioListDesktop from "./PortfolioListDesktop";
import { MAX_RESPONSIVE_MOBILE } from "store/constants";
import "./style.css";
import { getPortfolios } from "services/Portfolio";

const PortfolioList = (props) => {
  const [portfolioList, setPortfolioList] = useState(null);

  async function fetchPortfolios() {
    const result = await getPortfolios();

    setPortfolioList(result);
  }

  useEffect(() => {
    fetchPortfolios();
  }, []);

  return (
    <>
      <div className="w-full portfolio-slider">
        {props.windowDimension.width > MAX_RESPONSIVE_MOBILE ? (
          <PortfolioListDesktop data={portfolioList} />
        ) : (
          <PortfolioListMobile data={portfolioList} />
        )}
      </div>
    </>
  );
};

export default withDimension(PortfolioList);
